import { ReduxMetaData } from '@Types/reduxMetaData.types';

export enum DeviceStatus {
	Unknown = 'UNKNOWN',
	Resample = 'RESAMPLE',
	Complete = 'COMPLETE',
	Unavailable = 'UNAVAILABLE',
	CheckingStatus = 'CHECKING',
}

export interface SensorDetailsStoreState extends ReduxMetaData {
	deviceStatus: DeviceStatus;
	resampleJob: ReduxMetaData;
}
